import { createContext } from 'react';

/* istanbul ignore next */
const RedirectCallbackContext = createContext<(redirectURL: string, redirectProps?: any) => void>(() => { });
export default RedirectCallbackContext;